import { dataFastForward } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFastForward = /*#__PURE__*/createIcon(dataFastForward)
export default IconFastForward
